'use client';

// react
import { useContext, useEffect } from 'react';
// contexts
import { DialogContext, DialogVariant } from '@/contexts/DialogContext';

// ----------------------------------------------------------------------

export type Settings = {
  variant?: DialogVariant;
  onAccept?: () => void;
  onCancel?: () => void;
  acceptText?: string;
  cancelText?: string;
};

const useDialog = (title?: string, settings?: Settings) => {
  const context = useContext(DialogContext);

  const { variant, onAccept, onCancel, acceptText, cancelText } = settings
    ? settings
    : {
        variant: undefined,
        onAccept: undefined,
        onCancel: undefined,
        acceptText: undefined,
        cancelText: undefined,
      };

  if (!context) throw new Error('Dialog context must be use inside DialogProvider');
  const { openDialog, closeDialog, initialize } = context;
  useEffect(
    () =>
      initialize({
        title,
        variant: variant || 'info',
        onAccept: onAccept || closeDialog,
        onCancel: onCancel || closeDialog,
        acceptText,
        cancelText,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { openDialog, closeDialog };
};

export default useDialog;
